import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';

import { ActionTypes } from '../../Administration/utils';
import { approvalButtonsConfig } from '../../AgGrid/Header/approvalButtonsConfig';
import {
  checkConsentStatusHandler,
  checkVerificationStatusHandler,
  getActionSettings,
  showActionButton,
} from '../../AgGrid/action-utils';
import CustomButton from '../CustomButton';

const ApprovalButtonsHeader = ({
  actionHandler,
  columnSettingsList,
  type,
  allowedActions,
  rowsChecked,
  dontShowButtons,
  setSelectedRowForForm,
}) => {
  const verificationActionSettings = useMemo(
    () =>
      getActionSettings(columnSettingsList, allowedActions, ActionTypes.VERIFY),
    [columnSettingsList, allowedActions]
  );

  const consentActionSettings = useMemo(
    () =>
      getActionSettings(
        columnSettingsList,
        allowedActions,
        ActionTypes.CONSENT_GIVE
      ),
    [columnSettingsList, allowedActions]
  );

  const showVerifyButton = useMemo(
    () => showActionButton(verificationActionSettings, allowedActions),
    [allowedActions, verificationActionSettings]
  );

  const showConsentButton = useMemo(
    () => showActionButton(consentActionSettings, allowedActions),
    [allowedActions, consentActionSettings]
  );

  const checkConsentStatus = useMemo(() => {
    const item = rowsChecked[0];
    return rowsChecked?.length === 1 && checkConsentStatusHandler(type)(item);
  }, [type, rowsChecked]);

  const checkVerificationStatus = useMemo(() => {
    const item = rowsChecked[0];
    return (
      rowsChecked?.length === 1 && checkVerificationStatusHandler(type)(item)
    );
  }, [type, rowsChecked]);

  const approvalButtons = useMemo(
    () =>
      approvalButtonsConfig(
        actionHandler,
        verificationActionSettings,
        consentActionSettings,
        checkConsentStatus,
        checkVerificationStatus,
        showVerifyButton,
        showConsentButton,
        dontShowButtons,
        setSelectedRowForForm
      ),
    [
      actionHandler,
      verificationActionSettings,
      consentActionSettings,
      checkConsentStatus,
      checkVerificationStatus,
      showVerifyButton,
      showConsentButton,
      dontShowButtons,
      setSelectedRowForForm,
    ]
  );

  return (
    <Row className="d-flex align-items-center justify-content-end pt-0 py-2">
      {approvalButtons.map((button, index) => (
        <Col
          md={3}
          key={index}
          className="d-flex align-items-center justify-content-end pt-0 pr-0"
        >
          <CustomButton {...button} />
        </Col>
      ))}
    </Row>
  );
};

export default ApprovalButtonsHeader;
